import React, { useRef } from "react";
import "./index.css";

/**
 * Shows text on one line inside a fixed width and ends it with "…" when it
 * doesn't fit. Hovering (or tapping, on phones) a cut-off value shows the
 * full text in a small toast. Values that already fit do nothing.
 *
 *   <TruncatedText text={operator.networkName} width={180} />
 *
 * `children` can be used for highlighted search text; `text` is still the
 * plain value shown in the toast.
 */
const TruncatedText = ({ text, width = 160, children, className = "" }) => {
  const ref = useRef(null);
  const value = text == null ? "" : String(text);

  const showFull = () => {
    const el = ref.current;
    if (!el || !value || el.scrollWidth <= el.clientWidth) return;
  };

  return (
    <span
      ref={ref}
      className={`truncated-text ${className}`}
      style={{ maxWidth: width }}
      onMouseEnter={showFull}
      onTouchStart={showFull}
      title={value}
    >
      {children ?? (value || "—")}
    </span>
  );
};

export default TruncatedText;
